module.exports = __webpack_public_path__ + "static/img/icon.9f4ae14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/icon.jpg
// module id = Nzzy
// module chunks = 1